import { render, staticRenderFns } from "./Scene16.vue?vue&type=template&id=4030224c&scoped=true"
import script from "./Scene16.vue?vue&type=script&lang=js"
export * from "./Scene16.vue?vue&type=script&lang=js"
import style0 from "./Scene16.vue?vue&type=style&index=0&id=4030224c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4030224c",
  null
  
)

export default component.exports